import { Button, ButtonProps } from '@chakra-ui/react'

const ElevatedButton = (props: ButtonProps) => {
  return (
    <Button colorScheme='primary' rounded='3xl' variant='solid' paddingX='6' {...props}></Button>
  )
}

export { ElevatedButton }
